import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { ListSilobagHistoryPayload, ListSilobagHistoryResponse } from './get-silobag-history.types';
import { transformIntoQueryParamString } from '@old/utils/service';

export async function listSilobagHistoryService({ query: rawQuery }: ListSilobagHistoryPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.get<ListSilobagHistoryResponse>(ENDPOINT.SILOBAGS_HISTORY, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
